/* assets/header-brand.js */

/* ========= ユーティリティ ========= */
function tokenize(q) {
  // "青 パーカー" などの引用符は 1 トークンとして扱う
  const tokens = (q.match(/"[^"]+"|\S+/g) || []).map(t => t.replace(/^"|"$/g, ''));
  return tokens.filter(Boolean);
}
function buildClauseForToken(t) {
  // ワイルドカードやフィールド指定を使った上級者クエリはそのまま許可
  if (/[:\*]/.test(t)) return t;
  // 通常語：タイトル部分一致 / タイトル完全一致 / ハンドル / タグ
  return `(title:*${t}* OR title:${t} OR handle:${t} OR tag:${t})`;
}
function looksExpanded(val){
  return /\(title:\*/.test(val) || /\bAND\b/.test(val) || /(?:\btitle:|\bhandle:|\btag:)/.test(val);
}
function tokensFromExpanded(q){
  if (!q) return [];
  const re = /\(title:\*([^*]+)\*[^)]*\)/g;
  let m, out = [];
  while((m = re.exec(q)) !== null){ out.push(m[1]); }
  return out;
}
function restorePopupDisplay(){
  const inp = document.getElementById('search_input_popup');
  if (!inp) return;
  const v = inp.value || '';
  if (!looksExpanded(v)) return;

  // 送信時に保存した生の語を優先
  let raw = null;
  try { raw = sessionStorage.getItem('popup_last_raw_q') || null; } catch(_){}

  // ない場合はURLの q から復元（/search から戻った直後など）
  if (!raw) {
    try {
      const urlQ = new URLSearchParams(location.search).get('q') || '';
      const toks = tokensFromExpanded(urlQ);
      if (toks.length) raw = toks.join(' ');
    } catch(_){}
  }
  if (!raw) return;

  inp.value = raw;
  inp.setAttribute('value', raw); // 再描画対策
  try { inp.dispatchEvent(new Event('input', { bubbles: true })); } catch(_){}
}

/* ========= DOM 準備できたら実行 ========= */
document.addEventListener('DOMContentLoaded', function () {
  /* ===== ハンバーガー & サブメニュー ===== */
  (function () {
    const $nav      = $('nav');
    const $subTitle = $('.submenu-title');       // 無ければ空のままでもOK
    const $subWrap  = $('.panel-sub .subwrap');  // L1（サブ）
    const $subWrap2 = $('.panel-sub .subwrap2'); // L2（サブのサブ）

    // ハンバーガー
    $('#nav_toggle').on('click', function (e) {
      e.preventDefault();
      $('header').toggleClass('open');
      $('.container,.head_menu_blur').toggleClass('add_container');
      $nav.toggleClass('add_nav');
      // 初期化
      $nav.removeClass('view-sub view-sub2');
      $subWrap.empty();
      $subWrap2.empty();
      $subTitle.text('');

      // openクラスがあるかどうかでz-index切り替え
      if ($('header').hasClass('open')) {
        $('.header-banner').css('z-index', '9');
      } else {
        $('.header-banner').css('z-index', '');
      }
    });

    // ルート → サブ
    $nav.on('click', '.root-menu li.has-sub > a', function (e) {
      e.preventDefault();
      const $li   = $(this).closest('li.has-sub');
      const title = $(this).text().trim();
      const $tmpl = $li.children('.submenu-template').first().clone(true, true);
      $subTitle.text(title);
      $subWrap.html($tmpl.html()); // li群のみコピー
      $nav.addClass('view-sub');   // 左: root -100% / 右: sub 0%
      // L2初期化
      $nav.removeClass('view-sub2');
      $subWrap2.empty();
    });

    // サブ（L1） → サブのサブ（L2）
    $nav.on('click', '.panel-sub .subwrap li.has-sub2 > a', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const $li    = $(this).closest('li.has-sub2');
      const label  = $(this).text().trim();
      const $tmpl2 = $li.children('.submenu-2-template').first().clone(true, true);
      $subWrap2.html($tmpl2.html());
      if ($subTitle.length) $subTitle.text(label);
      $nav.addClass('view-sub2');  // L1:-100% / L2:0%
    });

    // 戻るボタン
    $nav.on('click', '.submenu-back', function () {
      if ($nav.hasClass('view-sub2')) {
        // L2 → L1
        $nav.removeClass('view-sub2');
        setTimeout(() => { $subWrap2.empty(); }, 350);
        return;
      }
      if ($nav.hasClass('view-sub')) {
        // L1 → ルート
        $nav.removeClass('view-sub');
        setTimeout(() => { $subWrap.empty(); }, 350);
        $subTitle.text('');
        return;
      }
      // ルートなら全閉
      $('header').removeClass('open');
      $('.container,.head_menu_blur').removeClass('add_container');
      $nav.removeClass('add_nav');
    });

    // どの階層でも最終リンククリックでメニュー全閉
    $nav.on(
      'click',
      // L1では「サブを持たない li の a」だけを対象にする
      '.panel-sub .subwrap li:not(.has-sub2) > a, ' +
      // L2はすべて最終リンク扱い
      '.panel-sub .subwrap2 a, ' +
      // ルートもサブを持たないものだけ
      '.root-menu li:not(.has-sub) > a',
      function () {
        $('header').removeClass('open');
        $('.container,.head_menu_blur').removeClass('add_container');
        $nav.removeClass('add_nav view-sub view-sub2');
        $subWrap.empty();
        $subWrap2.empty();
        $subTitle.text('');
      }
    );
  })();

  /* ===== 検索ポップアップ ===== */
  (function(){
    const $pop = $('#search_popup');

    // 開く
    $('#search_btn').on('click', function(e){
      e.preventDefault();
      $pop.addClass('show').attr('aria-hidden', 'false');
      $('body').addClass('no-scroll');
      setTimeout(() => { $('#search_input_popup').trigger('focus'); }, 80);
    });

    // 閉じる共通関数
    function closeSearch(){
      $pop.removeClass('show').attr('aria-hidden', 'true');
      $('body').removeClass('no-scroll');
    }

    // ×ボタン / 背景クリック / Esc
    $('#search_clear').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      const popupInput = document.getElementById('search_input_popup');
      if (popupInput) {
        popupInput.value = '';
        try { popupInput.dispatchEvent(new Event('input', { bubbles: true })); } catch (_) {}
        popupInput.focus();
        try { sessionStorage.removeItem('popup_last_raw_q'); } catch (_){}
      }
    });
    // 背景クリックで閉じる（フォーム内は閉じない）
    $('#search_popup').on('click', function(e){
      if ($(e.target).closest('.search-shell').length === 0) closeSearch();
    });
    $(document).on('keydown', function(e){ if(e.key === 'Escape') closeSearch(); });

    // フォーム内クリックは閉じない
    $('#search_form_popup').on('click', function(e){ e.stopPropagation(); });

    // 送信時：クエリ展開 + メタフィールドフィルタ投入
    const popupForm  = document.getElementById('search_form_popup');
    const popupInput = document.getElementById('search_input_popup');

    if (popupForm && popupInput) {
      popupForm.addEventListener('submit', function (e) {
        let q = popupInput.value || '';
        // 全角スペース→半角、前後trim、連続スペース1つ
        q = q.replace(/\u3000/g, ' ').trim().replace(/\s+/g, ' ');
        if (!q) { e.preventDefault(); return; }

        try { sessionStorage.setItem('popup_last_raw_q', q); } catch(_){}

        // 先頭が * の場合はそのまま
        if (q.startsWith('*')) {
          popupInput.value = q;
        }
        // すでにフィールド指定がある場合は尊重
        else if (/(\btitle:|\bhandle:|\btag:|\bbody:|\bproduct_type:|\bvendor:)/.test(q)) {
          popupInput.value = q;
        }
        // 通常ワードならANDで展開
        else {
          const tokens = tokenize(q);
          const clauses = tokens.map(buildClauseForToken);
          const finalQ = clauses.join(' AND ');
          popupInput.value = finalQ;
        }

        // チェックでメタフィールドフィルタを付与
        // name="filter.p.m.custom._main-brand" に値を入れる
        const onlyBrand   = document.getElementById('only_brand');
        const brandHidden = document.getElementById('search_brand_popup');
        const filterBrand = document.getElementById('filter_brand'); // visible/hidden どちらでもOK

        if (onlyBrand && brandHidden) {
          const val = (filterBrand && filterBrand.value) ? filterBrand.value : 'JIGGYS SHOP';
          brandHidden.value = onlyBrand.checked ? val : '';
        }
      });
    }

    // 表示だけ「ユーザーの入力」に戻す（/search から戻った時など）
    restorePopupDisplay();
    window.addEventListener('pageshow', restorePopupDisplay);
  })();
});
